import { useEffect } from 'react';
import i18n from './index';
import { supabase } from '../supabaseClient';

// Loads the logged-in user's saved language from user_preferences once their id is known,
// and applies it. Logged-out/pre-auth pages never call this -- they rely solely on i18n's
// own localStorage-backed state (see src/i18n/index.js).
export function useLanguagePreference(userId) {
  useEffect(() => {
    if (!userId) return;
    let cancelled = false;
    supabase
      .from('user_preferences')
      .select('language')
      .eq('user_id', userId)
      .maybeSingle()
      .then(({ data }) => {
        if (!cancelled && data?.language) i18n.changeLanguage(data.language);
      });
    return () => { cancelled = true; };
  }, [userId]);
}
